// @ts-nocheck

/**
 * * `template` - template
 * `ai_generation` - ai_generation
 */
export type StorefrontSessionCreateGenerationModeEnum =
  typeof StorefrontSessionCreateGenerationModeEnum[keyof typeof StorefrontSessionCreateGenerationModeEnum];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const StorefrontSessionCreateGenerationModeEnum = {
  template: "template",
  ai_generation: "ai_generation",
} as const;
